import React from 'react';
import './overlay_loader.css'; // Add styles for the loader here.

const OverlayLoader = () => {
  return (
    <div className="loader-overlay">
      <div className="loader-spinner"></div>
    </div>
  );
};

export default OverlayLoader;
